import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import UserProfileDropdown from '../../../components/UserProfile/UserProfile'
import Sidebar from '../../../components/Sidebar/Sidebar'
import {
    faSearch,
    faBell,
    faQuestionCircle,
} from "@fortawesome/free-solid-svg-icons";
import SeedsLogo from "../../../assets/images/SeedsLogo.png";
import "../TrancheDashboard.css";
import Tabs from '../../../components/Tab/Tabs';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getSingleTrancheData } from '../../../redux/TrancheReducer/action';
import ActiveTrancheDetails from './ActiveTrancheDetails';
import DisbursalDetails from './DisbursalDetails';
import PaymentHistory from './PaymentHistory';
import { ArrowLeft } from 'react-bootstrap-icons';
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';

const ActiveTrancheView = () => {
    // const [searchParams] = useSearchParams();

    // const trancheId = searchParams.get("trancheId");
    const { trancheId, trancheStatus } = useParams();
    const [activeTrancheTab, setActiveTrancheTab] = useState('tranche-details');

    const activeTrancheTabMapping = {
        'tranche-details': 'Tranche Details',
        'disbursal-details': 'Disbursal Details',
        'payment-history': 'Payment History',
    }

     const { singleTrancheData } = useSelector((store) => {
        return {
            singleTrancheData: store.TrancheReducer.singleTranche
        }
    })

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const fromRoute = location.state?.from || sessionStorage.getItem('fromRoute') || '';
    const cameFromApplication = /^\/applications\/[^/]+/.test(fromRoute);

    useEffect(() => {
        if(trancheId){
            dispatch(getSingleTrancheData(trancheId));
        }
    }, [trancheId, dispatch]);

    useEffect(() => {
        if (location.state?.from) {
            sessionStorage.setItem('fromRoute', location.state.from);
        }
    }, [location.state]);

    const renderContent = (tab) => {
        switch(tab){
            case 'tranche-details': 
                return <ActiveTrancheDetails />
            case 'disbursal-details':
                return <DisbursalDetails trancheData={singleTrancheData} />
            case 'payment-history':
                return <PaymentHistory trancheData={singleTrancheData} />
            default:
                return <ActiveTrancheDetails />
        }
    }

    const handleBack = () => {
        const from =
            location.state?.from ||
            sessionStorage.getItem('fromRoute');

        if (from) {
            navigate(from);
        } else {
            navigate(-1);
        }
    };

  return (
        <div className="trancheDashboardContainer">
            <div className="trancheDashboard">
                <Sidebar />

                <div className="dashboardMainContent">
                    <div className="contentHeader">
                        <div className="userLogo">
                            <img src={SeedsLogo} alt="logo" className="SeedsLogo" />
                        </div>
                        <div className="headerRightPanel">
                            {/* <div className="headerSearchBar">
                                <input type="text" placeholder="Search" />
                                <FontAwesomeIcon icon={faSearch} />
                            </div>
                            <div className="headerNotifications">
                                <FontAwesomeIcon icon={faBell} />
                                <span className="notificationBadge">9+</span>
                            </div>
                            <div className="headerHelp">
                                <FontAwesomeIcon icon={faQuestionCircle} />
                            </div> */}
                            <UserProfileDropdown />
                        </div>
                    </div>
                    <div className="pageContentWrapper">
                        <div className="pageHeaderSection">
                            {
                                cameFromApplication ? (
                                    <div className='pageBreadcrumbs'>
                                        <button
                                            className='tranche-btn back-btn'
                                            onClick={handleBack}
                                        >
                                            <ArrowLeft />
                                            Back to Application
                                        </button>
                                    </div>
                                ) : (

                            <Breadcrumb items={[
                                { label: 'Tranche View', onClick: () => navigate('/tranche-view') },
                                trancheStatus === 'approved'
                                    ? { label: 'Active', onClick: () => navigate('/tranche-view?tab=active') }
                                    : { label: 'Closed', onClick: () => navigate('/tranche-view?tab=closed') },
                                { label: activeTrancheTabMapping[activeTrancheTab] }
                            ]} />
                                )
                            }

                            {
                                trancheStatus === "approved" ?
                                <Tabs
                                    component={"ActiveTrancheView"}
                                    activeTab={activeTrancheTab}
                                    setActiveTab={setActiveTrancheTab}
                                /> :
                                <Tabs
                                    component={"ClosedTrancheView"}
                                    activeTab={activeTrancheTab}
                                    setActiveTab={setActiveTrancheTab}
                                /> 
                            }
                        </div>


                        <main className="active-tranche">
                            {singleTrancheData ? renderContent(activeTrancheTab) : <div>Loading...</div>}
                        </main>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ActiveTrancheView